import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async liberarCompra(api, parametros) {
    parametros.operacao = 'liberarCompra';

    let retorno = {};

    await api.santriPOST('/rest/compra', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCompra/RCompraLiberarCompra.js